import React, { useEffect, useState } from 'react'
import { Form, Button, Modal, Input, Icon, Tooltip } from 'antd'

import { formatLabel } from '../../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/utils'
import { CreatableSelect } from '../../../../components'
import { generateVideoStory } from '../../../../services/api/aiVideoGeneration'
import storyFormOptions from '../../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/components/Story/storyFormOptions'

const StoryCreationForm = Form.create()(
  ({
    form,
    inputMethod,
    initialText,
    onCancel,
    uploadedFile,
    onAddStory: addStory
  }) => {
    const { getFieldDecorator } = form

    const [isGeneratingStory, setIsGeneratingStory] = useState(false)
    const [story, setStory] = useState(null)
    const [isStoryVisible, setIsStoryVisible] = useState(false)

    const options = {
      storyObjective: {
        value: '',
        description:
          'The key concept to be tested (learning objective(s) that the scenario should address). <Open ended>'
      },
      ...storyFormOptions
    }

    console.log('uploadedFile', uploadedFile)

    const handleSubmit = e => {
      e.preventDefault()
      form.validateFields((err, values) => {
        if (!err) {
          const storyObjective = values.storyObjective
          const storyElements = JSON.stringify(values)

          setIsGeneratingStory(true)

          generateVideoStory({
            params: {
              story_objective: storyObjective,
              story_elements: storyElements,
              ...(inputMethod === 'text' && { course_content: initialText }),
              ...(inputMethod === 'upload' && {
                path: uploadedFile && uploadedFile.path
              })
            }
          })
            .then(res => {
              console.log('story res', res)
              const storyObj = res.data.body[0]
              const storyString =
                storyObj.beginning + storyObj.middle + storyObj.end
              setStory(removeReferenceList(storyString))
              setIsStoryVisible(true)
            })
            .finally(() => setIsGeneratingStory(false))
        }
      })
    }

    function removeReferenceList(text) {
      var pattern = /References:(.*?)(?=<\/p>)/gs

      var textWithoutReferences = text.replace(pattern, '').trim()

      return textWithoutReferences
    }

    const handleAddStory = () => {
      if (addStory) {
        addStory(story)
      }
    }

    return (
      <Modal
        width={800}
        title={isStoryVisible ? 'Edit Story' : 'Story Preferences'}
        centered
        visible
        onCancel={() => onCancel()}
        footer={null}
        className={isStoryVisible ? 'edit-story' : 'story-preferences'}
      >
        {!isStoryVisible && (
          <Form className="story-course-form" onSubmit={handleSubmit}>
            {Object.entries(options).map(([key, values]) => (
              <Form.Item
                labelAlign="top"
                label={
                  <span className="story-course-form-label">
                    <span>{formatLabel(key)} </span>
                    <Tooltip title={values.description}>
                      <Icon type="info-circle" />
                    </Tooltip>
                  </span>
                }
                key={key}
              >
                {getFieldDecorator(key, {
                  rules: [
                    {
                      required: true,
                      message: `Please input your ${formatLabel(key)}!`
                    }
                  ]
                })(
                  values.value && values.value.length > 0 ? (
                    <CreatableSelect
                      fieldKey={key}
                      updateOptionValue={(value, field) =>
                        form.setFieldsValue({ [field]: value })
                      }
                      options={values.value}
                      placeholder={`Select or type your ${formatLabel(key)}`}
                    />
                  ) : (
                    <Input.TextArea
                      placeholder={`Enter your ${formatLabel(key)}`}
                    />
                  )
                )}
              </Form.Item>
            ))}
            <div className="form-button-center">
              <Form.Item>
                <Button
                  loading={isGeneratingStory}
                  className="shl-primary-btn"
                  htmlType="submit"
                  shape="round"
                  size="large"
                >
                  Generate Story
                </Button>
              </Form.Item>
            </div>
          </Form>
        )}

        {isStoryVisible && (
          <StoryEditor
            data={story}
            onChange={setStory}
            onAddStory={handleAddStory}
          />
        )}
      </Modal>
    )
  }
)

const StoryEditor = ({ data, onChange, onAddStory }) => {
  const [story, setStory] = useState(null)

  useEffect(() => {
    if (data) {
      setStory(data)
    }
  }, [data])

  const handleChange = value => {
    setStory(value)
    onChange(value)
  }

  return (
    <div className="story-editor">
      <div className="story-editor__part">
        <Input.TextArea
          value={story}
          onChange={e => handleChange(e.target.value)}
          rows={10}
        ></Input.TextArea>
      </div>

      <Button className="shl-primary-btn" shape="round" onClick={onAddStory}>
        Use Story in Video
      </Button>
    </div>
  )
}

export default StoryCreationForm
